import { useRemoteConfig } from "@/hooks/remoteConfig/useRemoteConfig";

// kill switch, the banner shows unless the flag is set to false
const useIsWelcomeOfferEnabled = () => {
  const { loading, value } = useRemoteConfig("welcome_offer_banner_enabled");

  return { loading, isEnabled: !loading && (value?.asBoolean() ?? true) };
};

export { useIsWelcomeOfferEnabled };
